// extracted by mini-css-extract-plugin
module.exports = {"typewriter":"typewriter_typewriter__va_tv","typewriter__type":"typewriter_typewriter__type__3_sW5","typewriter__cursor":"typewriter_typewriter__cursor__b6f7G"};